var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseFilled = function SvgCloseFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1m4.374 6a.63.63 0 0 0-.441.182l-3.858 3.859a.105.105 0 0 1-.15 0l-3.858-3.86a.63.63 0 0 0-1.02.203.62.62 0 0 0 .138.68l3.857 3.865q.015.013.023.033a.1.1 0 0 1 .008.04.1.1 0 0 1-.031.073l-3.857 3.86A.622.622 0 0 0 7.626 17a.63.63 0 0 0 .441-.182l3.858-3.859a.105.105 0 0 1 .15 0l3.858 3.86a.63.63 0 0 0 1.02-.203.62.62 0 0 0-.138-.68l-3.857-3.86a.1.1 0 0 1-.031-.073q0-.023.008-.041a.1.1 0 0 1 .023-.033l3.857-3.865A.62.62 0 0 0 16.374 7",
    clipRule: "evenodd"
  })));
};
export default SvgCloseFilled;